export enum ExpansionStates {
  CONTRACTED = 'C',
  CONTRACTING = 'EtoC',
  EXPANDED = 'E',
  EXPANDING = 'CtoE'
}
